import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import type { ComponentProps } from "widgets/BaseComponent";
import _ from "lodash";
import "./index.css";
import styled from "styled-components";
import { parseWidgetData, strToJson, uuid2 } from "@byk/utils/Utils";
import BaiduMap from "@byk/pages/components/BMapWidget";
import { Effects } from "@icon-park/react/es/map";
import { Button } from "antd";
import { MapApiLoaderHOC } from "react-bmapgl";
import { commitUpdateSyncBatchUpdateWidgetMetaProperties } from "ce/sagas/ActionExecution/XActionExecutionSagas";
import { getStorage } from "utils/localStorage";

const ContainerWrapper = styled.div<{
}>`
  height:'300px';
`;

function BmapComponent (props: any) {
  const {
    value,
    onChange,
    isSearch,
    dragEnable,
    zoomEnable,
    zoomLevel,
    currentData,
    isShowCard,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    centerLnglat,
    rotation,
    pitch,
    viewMode,
    isSetCenter,
    isShowPolyline,
    enableDoubleClickZoom,
    enableRotate,
    enableTilt,
    noChooseMarkerColor,
    chooseMarkerColor,
    onMarkerRightClick,
    onMapClick,
    contentCfg,
    isShowDrawingManager,
    InfoWindowWidth,
    titleCfg,
    iconWidth,
    iconHeight,
    isShowSelect,
    onDataChange,
    isEnableMarkerRightClick,
    extData,
    chooseAddress,
    coverageRadius,
    onCurrentLocationChange,
    enableDistance,
    enableChoosePoint,
    locationMarkerKey,
    currentLocationKey
  } = props;
  const doPositionRef = useRef<any>(0);
  const _value = parseWidgetData(value || currentData);
  type BaiduMapRef = {
   setGroupShow: (isShow: boolean) => void;
  };

  const chooseMapRef = useRef<any>(null);
  const onItemClick = (v: any) => {
    onChange && onChange(v);
  }
  const  parseJsonToArray=(str:any)=> {
    if (typeof str !== 'string') {
        return [];
    }
    const trimmed = str.trim();
    if (!trimmed) {
        return [];
    }
    try {
        let jsonStr = trimmed;
        const firstChar = jsonStr[0];
        const lastChar = jsonStr[jsonStr.length - 1];
        
        if ((firstChar === "'" && lastChar === "'") ||
            (firstChar === '"' && lastChar === '"') ||
            (firstChar === '`' && lastChar === '`')) {
            jsonStr = jsonStr.slice(1, -1);
        }
        const parsed = JSON.parse(jsonStr);
        if (Array.isArray(parsed)) {
            return parsed;
        }
        if (parsed && typeof parsed === 'object') {
            return [];
        }
        return [];
    } catch (error) {
        return [];
    }
}
  const getBmapMappingData=(data:any, keepPrefix = true)=> {
    if (Array.isArray(data)) {
        return data.map(item => getBmapMappingData(item, keepPrefix));
    }
    if (data && typeof data === 'object') {
        const result:any = {};
        Object.keys(data).forEach(key => {
            if (key.includes(`${props.widgetName}.mapping`)) {
                if (keepPrefix) {
                    result[key] = data[key];
                } else {
                    const newKey = key.replace(`${props.widgetName}.mapping.`, '');
                    result[newKey] = data[key];
                }
            }
            else{
               result[key] = data[key];
            }
        });
        return result;
    }
    return data;
}


useEffect(() => {
  console.log("------isShowSelect--------------",isShowSelect)
    chooseMapRef.current?.setGroupShow(isShowSelect)
}, [isShowSelect]);


useEffect(() => {
  if(extData!=null&&extData!=undefined){
    chooseMapRef.current?.setPointsByExtData(extData)
    console.log(extData)
  }
}, [extData]);

const doOnCurrentLocationChange=(_location:any,isFlag:boolean=false)=>{
  if(isFlag){
    doPositionRef.current=0;
  }
  if(doPositionRef.current==0){
    onCurrentLocationChange(_location,getStorage(locationMarkerKey)=="0")
    doPositionRef.current=doPositionRef.current+1;
  }
}

const DataDom = useCallback((props:any) => {
  return <BaiduMap
      ref={chooseMapRef}
      callback={onItemClick}
      mode={"view"}
      defaultLngLat={_value}
      currentData={getBmapMappingData(_value,false)}
      centerLnglat={centerLnglat&&centerLnglat[0]}
      isShowCard={isShowCard}
      dragEnable={dragEnable}
      zoomLevel={zoomLevel}
      zoomEnable={zoomEnable}
      isSearch={isSearch}
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      rotation={rotation}
      pitch={pitch}
      viewMode={viewMode}
      boxShadow={boxShadow}
      //mapStyle={mapStyle}
      //features={features}
      isSetCenter={isSetCenter}
      isShowPolyline={isShowPolyline}
      /** 是否开启双击鼠标缩放 */
      enableDoubleClickZoom={enableDoubleClickZoom}
      /** 是否开启地图旋转功能 */
      enableRotate={enableRotate}
      /** 是否开启地图倾斜功能 */
      enableTilt={enableTilt}
      noChooseMarkerColor={noChooseMarkerColor}
      chooseMarkerColor={chooseMarkerColor}
      onMarkerRightClick={onMarkerRightClick}
      onMapClick={onMapClick}
      onDataChange={onDataChange}
      contentCfg={contentCfg}
      isShowDrawingManager={isShowDrawingManager}
      InfoWindowWidth={InfoWindowWidth}
      titleCfg={titleCfg}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      isEnableMarkerRightClick={isEnableMarkerRightClick}
      chooseAddress={chooseAddress}
      coverageRadius={coverageRadius}
      onCurrentLocationChange={doOnCurrentLocationChange}
      enableDistance={enableDistance}
      enableChoosePoint={enableChoosePoint}
      locationMarkerKey={locationMarkerKey}
      currentLocationKey={currentLocationKey}
    />
  }, [
    value,
    isSearch,
    dragEnable,
    zoomEnable,
    zoomLevel,
    currentData,
    isShowCard,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    centerLnglat,
    rotation,
    pitch,
    viewMode,
    isSetCenter,
    isShowPolyline,
    enableDoubleClickZoom,
    enableRotate,
    enableTilt,
    noChooseMarkerColor,
    chooseMarkerColor,
    contentCfg,
    isShowDrawingManager,
    InfoWindowWidth,
    titleCfg,
    iconWidth,
    iconHeight,
    isEnableMarkerRightClick,
    coverageRadius,
    onCurrentLocationChange,
    enableDistance,
    enableChoosePoint,
    locationMarkerKey,
    currentLocationKey
  ]);

  return (
    <>
      <ContainerWrapper className="z-AmapViewWidget-ContainerWrapper" style={{
        height: "inherit",
        border: `${borderWidth}px solid ${borderColor || "#bcb3b3"}`,
        boxShadow: boxShadow,
        borderRadius: borderRadius
      }} {...props}>
        <DataDom></DataDom>
      </ContainerWrapper>
    </>
  )
};

export default MapApiLoaderHOC({ ak: '4YuxDaLyOsqf2SnUtS7ZI1gvlS8wRuSK' })(BmapComponent);
